import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import CreaCliente from './CreaCliente';
import CreaProyecto from './CreaProyecto';
import CreaPuesto from './CreaPuesto';
import { usePuestoTemp } from './usePuestoTemp';

const PuestoTemp = () => {
    const {
        toast,
        visibleCreaCli,
        setVisibleCreaCli,
        guardarCliente,
        visibleCreaProy,
        setVisibleCreaProy,
        guardarProyecto,
        visibleCreaPues,
        proyecto,
        guardarPuesto,
        cargaCliente,
        cliente,
        setCliente,
        lstCliente,
        handleNuevoCli,
        enproceso,
        cargaProyecto,
        setProyecto,
        lstProyecto,
        optionProyectoTemplate,
        handleNuevoProy,
        cargaPuesto,
        puesto,
        handleChangePuesto,
        lstPuesto,
        handleNuevoPuesto,
        fechaIni,
        setFechaIni,
        hoy,
        fechaFin,
        setFechaFin,
        handleConsultar,
        loadConsultar,
        disaButConsultar,
        cargaEmpleado,
        empleadoSelect,
        setEmpleadoSelect,
        lstEmpleados,
        horaIniGen,
        setHoraIniGen,
        horaFinGen,
        setHoraFinGen,
        llenarHoras,
        disaButCopiar,
        filasFecha,
        dateBodyTemplate,
        calendarIniBodyTemplate,
        calendarFinBodyTemplate,
        actionBodyTemplate,
        empleadoBodyTemplate,
        handleGuardar,
        disaButGuardar,
        loadGuardar, setVisibleCreaPues
    } = usePuestoTemp();

    return (
        <div className="card">
            <h4>Creacion de Puestos Temporales</h4>
            <Toast ref={toast} />
            <Dialog visible={visibleCreaCli} onHide={() => setVisibleCreaCli(false)} style={{ width: '50vw' }}>
                <CreaCliente onSave={guardarCliente} />
            </Dialog>
            <Dialog visible={visibleCreaProy} onHide={() => setVisibleCreaProy(false)} style={{ width: '50vw' }}>
                <CreaProyecto cliente={cliente} onSave={guardarProyecto} />
            </Dialog>
            <Dialog visible={visibleCreaPues} onHide={() => setVisibleCreaPues(false)} style={{ width: '50vw' }}>
                <CreaPuesto proyecto={proyecto} onSave={guardarPuesto} />
            </Dialog>
            <div className="formgrid grid p-fluid mb-3">
                {/* Cliente  */}
                <div className="field col-12 md:col-4">
                    <label htmlFor="cboCliente">Cliente: </label>
                    {cargaCliente ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown inputId="cboCliente" value={cliente} onChange={(e) => setCliente(e.value)} options={lstCliente} placeholder="Selecciona un Cliente" optionLabel="nombre" filter showClear disabled={enproceso} />
                    )}
                </div>
                <div className="field col-12 md:col-2  flex align-items-end">
                    <Button icon="pi pi-plus" tooltip="Crear Cliente" onClick={handleNuevoCli} disabled={enproceso} />
                </div>
                <div className="field col-12 md:col-6">
                    <span></span>
                </div>
                {/* Proyecto  */}
                <div className="field col-12 md:col-4">
                    <label htmlFor="cboProyecto">Proyecto: </label>
                    {cargaProyecto ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown inputId="cboProyecto" value={proyecto} onChange={(e) => setProyecto(e.value)} options={lstProyecto} placeholder="Selecciona un Proyecto" optionLabel={optionProyectoTemplate} filter showClear disabled={enproceso} />
                    )}
                </div>
                <div className="field col-12 md:col-2 flex align-items-end">
                    <Button icon="pi pi-plus" tooltip="Crear Proyecto" onClick={handleNuevoProy} disabled={enproceso} />
                </div>
                <div className="field col-12 md:col-6">
                    <span></span>
                </div>
                {/* Puesto  */}
                <div className="field col-12 md:col-4">
                    <label htmlFor="cboPuesto">Puesto Dinámico: </label>
                    {cargaPuesto ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <Dropdown inputId="cboPuesto" value={puesto} onChange={(e) => handleChangePuesto(e)} options={lstPuesto} placeholder="Selecciona un Proyecto" optionLabel="descripcion" filter showClear disabled={enproceso} />
                    )}
                </div>
                <div className="field col-12 md:col-2  flex align-items-end">
                    <Button icon="pi pi-plus" tooltip="Crear Puesto" onClick={handleNuevoPuesto} disabled={enproceso} />
                </div>
                <div className="field col-12 md:col-6">
                    <span></span>
                </div>
                {/* Fechas */}
                <div className="field col-12 md:col-4">
                    <label>Fecha Desde: </label>
                    <Calendar value={fechaIni} onChange={(e) => setFechaIni(e.value)} dateFormat="dd/mm/yy" showIcon minDate={hoy} />
                </div>
                <div className="field col-12 md:col-4">
                    <label>Fecha Hasta: </label>
                    <Calendar value={fechaFin} onChange={(e) => setFechaFin(e.value)} dateFormat="dd/mm/yy" showIcon />
                </div>
                <div className="field col-12 md:col-4 flex align-items-end">
                    <Button label="Consultar" icon="pi pi-search" onClick={handleConsultar} loading={loadConsultar} disabled={disaButConsultar} />
                </div>
                {/* Empleado */}
                <div className="field col-12 md:col-4">
                    <label>Empleado:</label>
                    {cargaEmpleado ? (
                        <div className="flex align-items-center">
                            <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />
                        </div>
                    ) : (
                        <MultiSelect value={empleadoSelect} onChange={(e) => setEmpleadoSelect(e.value)} options={lstEmpleados} optionLabel="nombre" optionValue="personaId" placeholder="Seleccione Empleado" maxSelectedLabels={2} filter />
                    )}
                </div>
                <div className="field col-12 md:col-2">
                    <label>Hora Ini. Gral: </label>
                    <Calendar value={horaIniGen} onChange={(e) => setHoraIniGen(e.value)} timeOnly />
                </div>
                <div className="field col-12 md:col-2">
                    <label>Hora Fin Gral: </label>
                    <Calendar value={horaFinGen} onChange={(e) => setHoraFinGen(e.value)} timeOnly />
                </div>
                <div className="field col-12 md:col-2 flex align-items-end">
                    <label>{'  '}</label>
                    <Button label="Copiar a filas Vacias" onClick={llenarHoras} disabled={disaButCopiar} />
                </div>
                {/* Detalle de fechas */}
                <div className="field col-12 md:col-10">
                    <DataTable value={filasFecha} emptyMessage="Selecciona un rango de fechas para generar las filas." size="small" dataKey="id" style={{ width: '60vw' }}>
                        {/*<Column selectionMode="multiple" headerStyle={{ width: '3em' }} /> */}
                        <Column field="fecha" header="Fecha" body={dateBodyTemplate} style={{ width: '10vw' }} />
                        <Column field="horaIni" header="Hora Inicio" body={calendarIniBodyTemplate} style={{ width: '15vw' }} />
                        <Column field="horaFin" header="Hora Fin" body={calendarFinBodyTemplate} style={{ width: '15vw' }} />
                        <Column header="Acciones" body={actionBodyTemplate} style={{ width: '15vw' }} />
                        <Column header="Empleados" body={empleadoBodyTemplate} style={{ width: '30vw' }} />
                    </DataTable>
                </div>
                <div className="field col-12 md:col-2">
                    <Button label="Registrar cambios" onClick={handleGuardar} disabled={disaButGuardar} loading={loadGuardar} />
                </div>
            </div>
        </div>
    );
};

export default PuestoTemp;
